"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new /** @class */ (function () {
    function TypeHelper() {
    }
    TypeHelper.prototype.isString = function (x) {
        return Object.prototype.toString.call(x) === '[object String]';
    };
    return TypeHelper;
}());
